import { render, staticRenderFns } from "./MemberUnitDetail.vue?vue&type=template&id=9e63318a&scoped=true&"
import script from "./MemberUnitDetail.vue?vue&type=script&lang=js&"
export * from "./MemberUnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberUnitDetail.vue?vue&type=style&index=0&id=9e63318a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e63318a",
  null
  
)

export default component.exports